type FrameProps = {
  children: React.ReactNode;
};

const Frame = ({ children }: FrameProps) => {
  return (
    <section className="bg-gray-200 dark:bg-gray-700">
      <div className="max-w-screen-xl px-4 py-10 mx-auto lg:px-6">
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <div className="flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border border-gray-100 rounded-lg shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">
            {children}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Frame;
